export const validaTelefone = phone => {
  phone = phone.replace(' ', '');
  // eslint-disable-next-line prefer-regex-literals
  const regex = new RegExp('^s*[0-9]{2}s?(([0-9]{5})|([0-9]{4}))-?(([0-9]{4})|([0-9]{5}))$');
  return regex.test(phone);
};
